// React Basic and Bootstrap
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Row,
} from 'reactstrap';

// v3 Screenshots
import ImageHighlight from '../../assets/images/v3/highlight.png';
import ImageAddWord from '../../assets/images/v3/add_word.png';
import ImageMyWords from '../../assets/images/v3/my_words.png';
import ImageDiscover from '../../assets/images/v3/discover.png';
import ImageWordDetail1 from '../../assets/images/v3/1.png';
import ImageWordDetail2 from '../../assets/images/v3/2.png';
import ImageWordDetail3 from '../../assets/images/v3/3.png';
import ImageWritingHelper from '../../assets/images/v3/writing_helper.png';
import ImageQuiz from '../../assets/images/v3/quiz.png';
import ImageWordOfDay from '../../assets/images/v3/word_of_day_notification.png';

import BackToTop from '../../components/Layout/backToTop';
import { FREE_VERSION } from '../../config';
import Pricing from './Pricing';
import Testi from './Testi';
import Section from './Section';

const featureImageStyle = {
  width: '100%',
  borderRadius: 16,
  border: '1px solid rgba(139, 92, 246, 0.2)',
  boxShadow: '0 8px 28px rgba(15, 23, 42, 0.09)',
  display: 'block',
  margin: '0 auto',
};


const Index = () => {
  useEffect(() => {
    document.body.classList = '';
    window.addEventListener('scroll', scrollNavigation, true);
  });

  const scrollNavigation = () => {
    var doc = document.documentElement;
    const navBar = document.getElementById('topnav');
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (navBar != null) {
      if (top > 80) {
        navBar.classList.add('nav-sticky');
      } else {
        navBar.classList.remove('nav-sticky');
      }
    }
  };

  const [col1, setCol1] = useState(false);
  const [col2, setCol2] = useState(false);
  const [col3, setCol3] = useState(false);
  const [col4, setCol4] = useState(false);
  const [col5, setCol5] = useState(false);

  return (
    <React.Fragment>
      <Section />

      <div className="position-relative">
        <div className="shape overflow-hidden text-light">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor" />
          </svg>
        </div>
      </div>

      {/* Section intro label */}
      <Container className="mt-5 pt-4 text-center">
        <span
          className="badge rounded-pill text-uppercase fw-bold"
          style={{
            background: 'rgba(139, 92, 246, 0.08)',
            color: '#7c3aed',
            fontSize: '0.78rem',
            letterSpacing: '0.08em',
            padding: '0.5rem 1rem',
            border: '1px solid rgba(139, 92, 246, 0.18)',
          }}
        >
          What HighVocab Can Do
        </span>
        <h2
          className="mt-3 mb-2"
          style={{ fontSize: 'clamp(1.6rem, 2.5vw, 2.2rem)', fontWeight: 700, color: '#0f172a' }}
        >
          Everything You Need to Learn English Words
        </h2>
        <p
          className="text-muted mx-auto"
          style={{ maxWidth: 560, fontSize: '1.05rem', lineHeight: 1.7 }}
        >
          HighVocab helps you save, understand, and remember new words — while you browse the web.
        </p>
      </Container>

      {/* Feature 0 — FEATURED: Word Detail (3 images) */}
      <div
        className="mt-100 mt-60"
        style={{
          background: 'linear-gradient(135deg, #f0fdf8 0%, #eef4ff 100%)',
          borderTop: '1px solid rgba(11, 138, 117, 0.1)',
          borderBottom: '1px solid rgba(11, 138, 117, 0.1)',
          padding: '48px 0',
        }}
      >
        <Container>
          <Row className="justify-content-center mb-4">
            <Col lg={8} md={10} className="text-center">
              <span
                className="badge rounded-pill mb-3 d-inline-block"
                style={{
                  background: 'linear-gradient(135deg, #d1fae5, #a7f3d0)',
                  color: '#065f46',
                  fontSize: '0.78rem',
                  fontWeight: 700,
                  letterSpacing: '0.06em',
                  padding: '0.45rem 0.9rem',
                  textTransform: 'uppercase',
                  border: '1px solid rgba(16, 185, 129, 0.2)',
                }}
              >
                Most Helpful Feature
              </span>
              <h4 className="title mb-3" style={{ fontSize: '1.6rem' }}>
                Learn Every Word the Right Way
              </h4>
              <p className="sec-title mb-0" style={{ maxWidth: 600, margin: '0 auto' }}>
                Open any word to see its full definition, real examples, common phrases, word forms, and similar words — all in one screen. No dictionary tabs. No searching.
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center g-3 mt-2">
            <Col lg={4} md={4} sm={4} className="text-center">
              <img
                src={ImageWordDetail1}
                alt="Word detail — definition and examples"
                style={{ width: '100%', borderRadius: 14, border: '1px solid rgba(11, 138, 117, 0.25)', boxShadow: '0 8px 24px rgba(15, 23, 42, 0.09)' }}
              />
            </Col>
            <Col lg={4} md={4} sm={4} className="text-center">
              <img
                src={ImageWordDetail2}
                alt="Word detail — word forms and phrases"
                style={{ width: '100%', borderRadius: 14, border: '1px solid rgba(11, 138, 117, 0.25)', boxShadow: '0 8px 24px rgba(15, 23, 42, 0.09)' }}
              />
            </Col>
            <Col lg={4} md={4} sm={4} className="text-center">
              <img
                src={ImageWordDetail3}
                alt="Word detail — related words"
                style={{ width: '100%', borderRadius: 14, border: '1px solid rgba(11, 138, 117, 0.25)', boxShadow: '0 8px 24px rgba(15, 23, 42, 0.09)' }}
              />
            </Col>
          </Row>
        </Container>
      </div>

      {/* Feature 1 — My Words (image left) */}
      <Container className="mt-100 mt-60">
        <Row className="align-items-center g-5">
          <Col lg={6} md={6}>
            <img src={ImageMyWords} style={featureImageStyle} alt="Personal saved word list" />
          </Col>
          <Col lg={6} md={6}>
            <p className="feature-eyebrow">Your Word List</p>
            <h4 className="feature-title">All Your Words in One Place</h4>
            <p className="feature-desc">
              See every saved word with its translation, pronunciation, and progress. Filter by learning or memorized to focus on what you still need to review.
            </p>
          </Col>
        </Row>
      </Container>

      {/* Feature 2 — Discover (image right) */}
      <Container className="mt-100 mt-60">
        <Row className="align-items-center g-5">
          <Col lg={6} md={6} className="order-2 order-md-1">
            <p className="feature-eyebrow">Find New Words</p>
            <h4 className="feature-title">Discover Words by Topic or Level</h4>
            <p className="feature-desc">
              Browse thousands of English words. Filter by topic or CEFR level from A1 to C2. Find words that match your goals and save them to your list.
            </p>
          </Col>
          <Col lg={6} md={6} className="order-1 order-md-2">
            <img src={ImageDiscover} style={featureImageStyle} alt="Discover words by topic and level" />
          </Col>
        </Row>
      </Container>

      {/* Feature 3 — Quiz (image left) */}
      <Container className="mt-100 mt-60">
        <Row className="align-items-center g-5">
          <Col lg={6} md={6}>
            <img src={ImageQuiz} style={featureImageStyle} alt="Quiz with multiple-choice questions" />
          </Col>
          <Col lg={6} md={6}>
            <p className="feature-eyebrow">Practice & Review</p>
            <h4 className="feature-title">Test Yourself with Short Quizzes</h4>
            <p className="feature-desc">
              Answer multiple-choice questions from your saved words. See your score and review what you missed — short and focused for daily practice.
            </p>
          </Col>
        </Row>
      </Container>

      {/* Feature 4 — Writing Helper (image right) */}
      <Container className="mt-100 mt-60">
        <Row className="align-items-center g-5">
          <Col lg={6} md={6} className="order-2 order-md-1">
            <p className="feature-eyebrow">Write Better English</p>
            <h4 className="feature-title">Fix or Write Sentences with AI</h4>
            <p className="feature-desc">
              Paste a sentence to get a clearer, more natural version. Or describe what you want to say and HighVocab will write a reply for you.
            </p>
          </Col>
          <Col lg={6} md={6} className="order-1 order-md-2">
            <img src={ImageWritingHelper} style={featureImageStyle} alt="Writing helper fixing and composing sentences" />
          </Col>
        </Row>
      </Container>

      {/* Feature 5 — Highlight (image left) */}
      <Container className="mt-100 mt-60">
        <Row className="align-items-center g-5">
          <Col lg={6} md={6}>
            <img src={ImageHighlight} style={featureImageStyle} alt="Words highlighted on a webpage" />
          </Col>
          <Col lg={6} md={6}>
            <p className="feature-eyebrow">While You Browse</p>
            <h4 className="feature-title">See Your Saved Words While You Read</h4>
            <p className="feature-desc">
              HighVocab highlights words you saved on any website. Hover to see the meaning, pronunciation, and an example — without leaving the page.
            </p>
          </Col>
        </Row>
      </Container>

      {/* Feature 6 — Notification (image right) */}
      <Container className="mt-100 mt-60">
        <Row className="align-items-center g-5">
          <Col lg={6} md={6} className="order-2 order-md-1">
            <p className="feature-eyebrow">Daily Reminder</p>
            <h4 className="feature-title">Stay Reminded While You Browse</h4>
            <p className="feature-desc">
              A small popup appears on the page while you browse to remind you to practice. No extra steps — it shows up right where you are.
            </p>
          </Col>
          <Col lg={6} md={6} className="order-1 order-md-2">
            <img src={ImageWordOfDay} style={featureImageStyle} alt="Word of the day notification popup" />
          </Col>
        </Row>
      </Container>

      {/* Feature 7 — Add Word (image left) */}
      <Container className="mt-100 mt-60">
        <Row className="align-items-center g-5">
          <Col lg={6} md={6}>
            <img src={ImageAddWord} style={featureImageStyle} alt="Adding a new word while browsing" />
          </Col>
          <Col lg={6} md={6}>
            <p className="feature-eyebrow">Save Words Instantly</p>
            <h4 className="feature-title">Add Any New Word in One Click</h4>
            <p className="feature-desc">
              Select an unfamiliar word on any page. HighVocab shows the definition and an example. Confirm with one click to save it to your list.
            </p>
          </Col>
        </Row>
      </Container>

      {!FREE_VERSION && <Pricing />}

      <section className="section pt-0" id="highvocab-faq">
        <Container className="mt-100 mt-60 md-padding-20">
          <Row className="justify-content-center">
            <Col xs={12} className="text-center">
              <div className="section-title">
                <h4 className="title mb-4">Frequently Asked Questions</h4>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={9} className="mt-4 pt-2">
              <div className="faq-content">
                <div className="accordion" id="accordionExample">
                  <Card className="border-0 rounded mb-2">
                    <Link
                      to="#"
                      onClick={() => setCol1(!col1)}
                      className={col1 ? 'faq position-relative text-primary' : 'faq position-relative text-dark'}
                    >
                      <CardHeader className="border-0 shadow bg-light p-3" id="headingOne">
                        <h6 className="title mb-0">
                          How do I add a new word to my list?
                          <i className={col1 ? 'mdi mdi-chevron-up float-end' : 'mdi mdi-chevron-down float-end'} />
                        </h6>
                      </CardHeader>
                    </Link>
                    <Collapse isOpen={col1}>
                      <CardBody>
                        <p className="text-muted mb-0 faq-ans">
                          Select the word you want to learn while you browse any website. A small pop-up will appear. Choose the definition and example you like, then click &quot;Add Word&quot; to save it to your list.
                        </p>
                      </CardBody>
                    </Collapse>
                  </Card>

                  <Card className="border-0 rounded mb-2">
                    <Link
                      to="#"
                      onClick={() => setCol5(!col5)}
                      className={col5 ? 'faq position-relative text-primary' : 'faq position-relative text-dark'}
                    >
                      <CardHeader className="border-0 shadow bg-light p-3">
                        <h6 className="title mb-0">
                          Can I see the full details of a word?
                          <i className={col5 ? 'mdi mdi-chevron-up float-end' : 'mdi mdi-chevron-down float-end'} />
                        </h6>
                      </CardHeader>
                    </Link>
                    <Collapse isOpen={col5}>
                      <CardBody>
                        <p className="text-muted mb-0 faq-ans">
                          Yes. Tap any word in your list or in Discover to open the Word Detail page. You will see the full definition, example sentences, word forms, related words, and common phrases — all in one place.
                        </p>
                      </CardBody>
                    </Collapse>
                  </Card>

                  <Card className="border-0 rounded mb-2">
                    <Link
                      to="#"
                      onClick={() => setCol2(!col2)}
                      className={col2 ? 'faq position-relative text-primary' : 'faq position-relative text-dark'}
                    >
                      <CardHeader className="border-0 shadow bg-light p-3" id="headingTwo">
                        <h6 className="title mb-0">
                          Can I see definitions for highlighted words on a webpage?
                          <i className={col2 ? 'mdi mdi-chevron-up float-end' : 'mdi mdi-chevron-down float-end'} />
                        </h6>
                      </CardHeader>
                    </Link>
                    <Collapse isOpen={col2}>
                      <CardBody>
                        <p className="text-muted mb-0 faq-ans">
                          Yes. Hover over any highlighted word on a webpage and a pop-up will show the translation, pronunciation, definition, and an example sentence right away.
                        </p>
                      </CardBody>
                    </Collapse>
                  </Card>

                  <Card className="border-0 rounded mb-2">
                    <Link
                      to="#"
                      onClick={() => setCol3(!col3)}
                      className={col3 ? 'faq position-relative text-primary' : 'faq position-relative text-dark'}
                    >
                      <CardHeader className="border-0 shadow bg-light p-3">
                        <h6 className="title mb-0">
                          What languages can I translate into?
                          <i className={col3 ? 'mdi mdi-chevron-up float-end' : 'mdi mdi-chevron-down float-end'} />
                        </h6>
                      </CardHeader>
                    </Link>
                    <Collapse isOpen={col3}>
                      <CardBody>
                        <p className="text-muted mb-0 faq-ans">
                          HighVocab is for English learners and supports translations into over 60 languages.
                        </p>
                      </CardBody>
                    </Collapse>
                  </Card>

                  <Card className="border-0 rounded mb-2">
                    <Link
                      to="#"
                      onClick={() => setCol4(!col4)}
                      className={col4 ? 'faq position-relative text-primary' : 'faq position-relative text-dark'}
                    >
                      <CardHeader className="border-0 shadow bg-light p-3">
                        <h6 className="title mb-0">
                          Can I export my word list?
                          <i className={col4 ? 'mdi mdi-chevron-up float-end' : 'mdi mdi-chevron-down float-end'} />
                        </h6>
                      </CardHeader>
                    </Link>
                    <Collapse isOpen={col4}>
                      <CardBody>
                        <p className="text-muted mb-0 faq-ans">
                          Yes. You can export your vocabulary list as a CSV file, which you can open in Microsoft Excel or any spreadsheet program.
                        </p>
                      </CardBody>
                    </Collapse>
                  </Card>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Testi />

      <div className="position-relative">
        <div className="shape overflow-hidden text-footer">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor" />
          </svg>
        </div>
      </div>

      <BackToTop />
    </React.Fragment>
  );
};

export default Index;
